module.exports = __webpack_public_path__ + "assets/img/12_43.4d6b1280.jpg";